import React from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "../Assets/svgs/CloseIcon";
import ExclamationMarkIcon from "../Assets/svgs/ExclamationMarkIcon";

const LowCreditModal = ({ onClose }) => {
  const navigate = useNavigate();

  const onPressRechargeNow = () => {
    navigate("/subscription");
  };

  return (
    <div className="modal modal--modalCredits modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <button className="btn btn__transparent btnClose" onClick={onClose}>
              <CloseIcon />
            </button>
          </div>
          <div className="modal__body">
            <span className="icon">
              <ExclamationMarkIcon />
            </span>
            <h4 className="title title--h3">Low on Credits!</h4>
            <p className="para">
              Please recharge with credits to <br />
              continue scheduling calls
            </p>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button className="btn btn__primary" onClick={onPressRechargeNow}>
                Recharge Now
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default LowCreditModal;
